module.exports = __webpack_public_path__ + "static/watch.096ea210.gif";


//////////////////
// WEBPACK FOOTER
// ./src/pages/debugger/img/p2/watch.gif
// module id = 566
// module chunks = 270304712061374